(() => {

    const _directiveDependencies = [];
    const _controllerDependencies = ['$scope', '$state', '$window'];

    /**
     * @ngdoc directive
     * @name directives.controller.ChangeLanguageController
     *
     * @description
     * change the language in the authentication pages controller
     */
    class ChangeLanguageController {

        /**
         * @param  {any} $scope
         * @param  {any} $state
         * @param  {any} $window
         */
        constructor($scope, $state, $window) {

            this.$scope = $scope;
            this.$state = $state;
            this.$window = $window;

            this.$scope.currentLanguage =
                CWCONFIG.languages[CWCONFIG.language] || CWCONFIG.language.toUpperCase();

        }

        /**
         * @ngdoc directive
         * @name directives.controller.ChangeLanguageController#openModal
         * @methodOf directives.controller.ChangeLanguageController
         *
         * @description
         * open the language modal
         */

        openModal(modal) {

            this.$state.go(`${this.$state.current.name}.ltb`, {
                ltb: modal,
            });

        }

    }

    /**
     * @ngdoc directive
     * @name directives.ChangeLanguageDirective
     *
     * @description
     * change the language in the authentication pages directive
     */
    class ChangeLanguageDirective {

        constructor() {

            this.template = require('./change-language.html');
            this.restrict = 'EA';
            this.replace = false;
            this.scope = {};

            _controllerDependencies.push(($scope, $state, $window) =>
                new ChangeLanguageController($scope, $state, $window));
            this.controller = _controllerDependencies;
            this.controllerAs = 'ChangeLanguageCtrl';

        }

    }

    _directiveDependencies.push(() => new ChangeLanguageDirective());


    angular.module('directives')
        .directive('changeLanguage', _directiveDependencies);

})();



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/auth/change-language/change-language.js